// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bundle-slider .v-slide-group .v-slide-group__wrapper{padding:25px 0}.bundle-slider .v-slide-group .v-slide-group__content{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}", ""]);
// Exports
module.exports = exports;
